import { Component } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { SelectedCompanyAPIModel } from 'src/app/models/api.model'
import { CommonService } from 'src/app/services/common/common.service'
import { KnowledgeService } from 'src/app/services/knowledge/knowledge.service'
import { CategorySelection } from '../../../models/api.model'

@Component({
  selector: 'app-knowledge-search',
  templateUrl: './knowledge-search.component.html',
  styleUrls: ['./knowledge-search.component.scss']
})
export class KnowledgeSearchComponent {
  searchKnowledgeForm: FormGroup
  selectedCompany: SelectedCompanyAPIModel
  constructor(
    private route: Router,
    private formBuilder: FormBuilder,
    private knowledgeService: KnowledgeService,
    private cs: CommonService
  ) {}

  queryParamValues = {
    pageNo: 0,
    pageLimit: 20,
    sortBy: 'heading',
    sortOrder: 'ASC'
  }

  ngOnInit() {
    this.buildSearchKnowledgeForm()
  }

  buildQueryParams = (): { key: string; value: string }[] => {
    return [
      {
        key: 'pageNo',
        value: this.queryParamValues.pageNo.toString()
      },
      {
        key: 'limit',
        value: this.queryParamValues.pageLimit.toString()
      },
      {
        key: 'sortBy',
        value: this.queryParamValues.sortBy
      },
      {
        key: 'sortOrder',
        value: this.queryParamValues.sortOrder
      }
    ]
  }

  buildSearchKnowledgeForm() {
    this.searchKnowledgeForm = this.formBuilder.group({
      heading: [''],
      category: ['']
    })
  }

  quickSearch() {
    const quickLinkPage = `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${GlobalConstants.ROUTING.QUICK_SELECT}`
    this.route.navigate([quickLinkPage])
  }

  search() {
    if (this.searchKnowledgeForm.valid) {
      const knowledge = this.searchKnowledgeForm.value
      let options = {
        queryParams: this.buildQueryParams(),
        searchRequestBody: knowledge,
        routeTo: this.cs.createRoutingURL([GlobalConstants.ROUTING.KNOWLEDGE_HUB, GlobalConstants.ROUTING.LIST])
      }
      this.knowledgeService.knowledgeRefresh.next(true)
      this.knowledgeService.dispatchSearchKnowledgeAction(options)
    }
  }

  onCategorySelected(categorySelection: CategorySelection) {
    const { selectedCategory } = categorySelection
    this.searchKnowledgeForm.patchValue({ category: selectedCategory })
  }

  get f() {
    return this.searchKnowledgeForm.controls
  }

  viewAll() {
    this.knowledgeService.knowledgeRefresh.next(false)
    const quickLinkPage = `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${GlobalConstants.ROUTING.LIST}`
    this.route.navigate([quickLinkPage])
  }

  addNew() {
    this.cs.routeTo(`/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/1`)
  }

  createNewKnowledgeArticle() {
    const now = new Date()
    const formattedDate = now.toLocaleDateString() + ' ' + now.toLocaleTimeString('en-US', { hour12: false })
    const knowledgeArticle = {
      contents: '',
      heading: 'Untitled ' + formattedDate,
      referenceVideo: '',
      displayForEmployee: false,
      displayForAdmin: true,
      companyReferenceId: this.selectedCompany.id,
      companyReferenceType: this.selectedCompany.type
    } as any
    this.knowledgeService.dispatchSaveKnowledgeAction(knowledgeArticle, null, '')
  }
}
